var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownExpandeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(180 32 32)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2185 17.2361C16.0734 17.2546 15.9266 17.2546 15.7815 17.2361C15.5504 17.2067 15.2924 17.096 14.8907 16.7734C14.4772 16.4413 13.9891 15.9505 13.28 15.235L11.5327 13.472C11.2411 13.1778 10.7662 13.1757 10.472 13.4673C10.1778 13.7589 10.1757 14.2338 10.4673 14.528L12.2461 16.3227C12.916 16.9987 13.4636 17.5511 13.9515 17.9429C14.4588 18.3504 14.9737 18.6453 15.5918 18.7241C15.8629 18.7586 16.1371 18.7586 16.4082 18.7241C17.0263 18.6453 17.5412 18.3504 18.0485 17.9429C18.5364 17.5511 19.084 16.9987 19.7539 16.3227L21.5327 14.528C21.8243 14.2338 21.8222 13.7589 21.528 13.4673C21.2338 13.1757 20.7589 13.1778 20.4673 13.472L18.72 15.235C18.0109 15.9505 17.5228 16.4413 17.1093 16.7734C16.7076 17.096 16.4496 17.2067 16.2185 17.2361Z",
    fill: "#062A41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownExpandeIcon);
export default __webpack_public_path__ + "static/media/downExpandeIcon.f064662f4382f2f003464d62ce9df9fc.svg";
export { ForwardRef as ReactComponent };